module.exports = __webpack_public_path__ + "static/img/bcg4.4577d809.png";